import request, { HttpMethod } from '@app/libs/request';
import config from '@app/config';
import { OrganizationSetup } from '@app/generated/svm';

export async function getOrganizationSetup(organizationId: string): Promise<OrganizationSetup> {
  return request<OrganizationSetup>(config.serverUrls.svm, `/api/back-office/organizations/:organizationId/setup`, {
    method: HttpMethod.get,
    pathParams: { organizationId },
    errorsHandler: {
      // The page shows its own error
      default: {
        message: 'Cannot get the organization setup.',
        suppressNotification: true,
      },
    },
  });
}
